import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    deleteIssuesListError, deleteIssuesListSuccess,

    getIssuesListError,
    getIssuesListSuccess
} from './actions';
import {
    ISSUES_DELETE_ITEMS, ISSUES_GET_LIST, ISSUES_GET_LIST_SEARCH,
    MY_POSTS_GET_LIST
} from './actions_def';


const apiUrl = servicePath;


function* getIssuesList({ payload }) {
    //// // console.log(payload);;
    if (!payload) {
        yield put(getIssuesListError({ error: 'prerequisites' }));
    }

    try {
        const response = yield call(getIssuesListRequest, payload);
        yield put(getIssuesListSuccess(response));
    } catch (error) {
        yield put(getIssuesListError(error));
    }
}



function* getMyPostsList({ payload }) {
    //// // console.log(payload);;
    if (!payload) {
        yield put(getIssuesListError({ error: 'prerequisites' }));
    }

    try {
        const response = yield call(getMyPostsRequest, payload);
        yield put(getIssuesListSuccess(response));
    } catch (error) {
        yield put(getIssuesListError(error));
    }
}



function* getIssuesListSearch({ payload }) {
    // // console.log(payload);;
    if (!payload) {
        yield put(getIssuesListError({ error: 'prerequisites' }));
    }

    try {
        const response = yield call(getIssuesListSearchRequest, payload);
        yield put(getIssuesListSuccess(response));
    } catch (error) {
        yield put(getIssuesListError(error));
    }
}

const getIssuesListRequest = async (payload) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        console.log(payload);;

        instance.get('/projects/' + payload.projectId + '/issues/')
            .then(response => success(response.data ?
                response.data.map(item => (item))
                :
                [])
            );
    })
        .then((response) => response)
        .catch((error) => error);
};


const getMyPostsRequest = async (payload) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        instance.get('/posts/myposts/',
        )
            .then(response => success(response.data ?
                response.data.map(item => (item))
                :
                [])
            );
    })
        .then((response) => response)
        .catch((error) => error);
};
const getIssuesListSearchRequest = async (payload) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'post',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // // console.log(payload);;

        instance.post('/projects/' + payload.projectId + '/issues/',
            {
                // crossdomain: true,
                projectId: payload.projectId,
                searchTerm: payload.searchTerm
            })
            .then(response => success(
                response.data ?
                    response.data.map(item => (item))
                    :
                    [])
            );
    })
        .then((response) => response)
        .catch((error) => error);
};
const deleteIssuesListRequest = async (items) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        // var _user = JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _status = 1;
        switch (items.status) {
            case "PENDING": _status = 1; break;
            default: _status = 1;
        };

        items.map(item => {
            console.log(item)
            instance.delete('/issues/' + item + '/',
                { crossdomain: true })
                .then(response => {
                    if (response.data) {
                        if (response.data.status === "fail") {
                            fail(response.data);
                        }
                        else if (response.data.status === "success" || response.data.status === "ok") {
                            success(response.data);
                        }
                        else {
                            console.log('Inconsistent behaviour', response.data.status)
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                });
        });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteIssuesList({ payload }) {
    // // console.log(payload);;

    try {
        const response = yield call(deleteIssuesListRequest, payload);
        yield put(deleteIssuesListSuccess(response));
    } catch (error) {
        yield put(deleteIssuesListError(error));
    }
}



export function* watchGetIssuesList() {
    yield takeEvery(ISSUES_GET_LIST, getIssuesList);
}

export function* watchGetMyPostsList() {
    yield takeEvery(MY_POSTS_GET_LIST, getMyPostsList);
}

export function* watchGetSearchIssuesList() {
    yield takeEvery(ISSUES_GET_LIST_SEARCH, getIssuesListSearch);
}

export function* watchDeleteIssues() {
    yield takeEvery(ISSUES_DELETE_ITEMS, deleteIssuesList);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetIssuesList),
        fork(watchGetSearchIssuesList),
        fork(watchDeleteIssues),
    ]);
}
